(() => {
  const header = document.querySelector('[data-site-header]');
  const trigger = header?.querySelector('[data-shop-menu-trigger]');
  const panel = header?.querySelector('[data-shop-mega-menu]');
  if (!header || !trigger || !panel) return;
  const desktop = window.matchMedia('(min-width: 901px)');
  const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const categories = [...panel.querySelectorAll('[data-shop-category]')];
  const categoryPanels = [...panel.querySelectorAll('[data-shop-category-panel]')];
  let activeCategory = 'all';
  const selectCategory = (key) => {
    if (!categories.some((link) => link.dataset.shopCategory === key)) return;
    activeCategory = key;
    categories.forEach((link) => {
      const selected = link.dataset.shopCategory === key;
      link.classList.toggle('is-active', selected);
      link.setAttribute('aria-expanded', String(selected));
    });
    categoryPanels.forEach((content) => { content.hidden = !content.dataset.shopCategoryPanel.split(' ').includes(key); });
  };
  categories.forEach((link, index) => {
    link.addEventListener('pointerenter', () => {
      if (hover.matches) {
        // Never hide a product that a keyboard user is currently focused on.
        if (categoryPanels.some((content) => content.contains(document.activeElement))) return;
        selectCategory(link.dataset.shopCategory);
      }
    });
    link.addEventListener('focusin', () => selectCategory(link.dataset.shopCategory));
    link.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'touch' && activeCategory !== link.dataset.shopCategory) {
        link.dataset.shopTouchReveal = 'true';
        selectCategory(link.dataset.shopCategory);
      }
    });
    link.addEventListener('click', (event) => {
      if (link.dataset.shopTouchReveal === 'true') {
        delete link.dataset.shopTouchReveal;
        event.preventDefault();
        event.stopPropagation();
      }
    });
    link.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        categories[(index + (event.key === 'ArrowDown' ? 1 : -1) + categories.length) % categories.length].focus();
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        categoryPanels.find((content) => !content.hidden)?.querySelector('a[href], button')?.focus();
      }
    });
  });
  let closeTimer;
  const cancelClose = () => window.clearTimeout(closeTimer);
  const close = (restoreFocus = false) => {
    cancelClose();
    panel.hidden = true;
    header.classList.remove('is-shop-open');
    trigger.setAttribute('aria-expanded', 'false');
    if (restoreFocus) trigger.focus();
  };
  const open = () => {
    cancelClose();
    if (!desktop.matches || document.body.classList.contains('is-locked')) return;
    header.querySelectorAll('[data-header-language].is-open').forEach((control) => {
      control.classList.remove('is-open');
      control.querySelector('[data-header-language-trigger]')?.setAttribute('aria-expanded', 'false');
      const menu = control.querySelector('[data-header-language-menu]');
      if (menu) menu.hidden = true;
    });
    header.querySelectorAll('.nav-dropdown[open]').forEach((dropdown) => { dropdown.open = false; });
    if (panel.hidden) selectCategory('all');
    panel.hidden = false;
    header.classList.add('is-shop-open');
    trigger.setAttribute('aria-expanded', 'true');
  };
  window.AvaShopMenu = { close, trigger, panel };
  trigger.addEventListener('pointerenter', () => { if (hover.matches) open(); });
  trigger.addEventListener('click', () => panel.hidden ? open() : close());
  trigger.addEventListener('keydown', (event) => {
    if (event.key !== 'ArrowDown') return;
    event.preventDefault();
    open();
    if (!panel.hidden) panel.querySelector('a[href], button')?.focus();
  });
  header.addEventListener('pointerenter', cancelClose);
  header.addEventListener('pointerleave', () => {
    if (hover.matches && !header.contains(document.activeElement)) closeTimer = window.setTimeout(close, 200);
  });
  header.querySelectorAll('.desktop-nav > a, .desktop-nav > details').forEach((link) => {
    link.addEventListener('pointerenter', () => { if (hover.matches) close(); });
    link.addEventListener('focusin', () => close());
  });
  header.addEventListener('focusout', () => {
    window.setTimeout(() => { if (!header.contains(document.activeElement)) close(); }, 0);
  });
  document.addEventListener('pointerdown', (event) => { if (!header.contains(event.target)) close(); });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !panel.hidden) {
      event.preventDefault();
      event.stopPropagation();
      close(true);
    }
  }, true);
  panel.addEventListener('click', (event) => { if (event.target.closest('a[href]')) close(); });
  desktop.addEventListener('change', () => {
    const needsFocus = panel.contains(document.activeElement) || document.activeElement === trigger;
    close();
    if (needsFocus) (desktop.matches ? trigger : header.querySelector('[data-open-mobile-menu]'))?.focus();
  });
})();
